import { render } from "./PatientAnagraph.vue?vue&type=template&id=dfe8c068&ts=true"
import script from "./PatientAnagraph.vue?vue&type=script&lang=ts"
export * from "./PatientAnagraph.vue?vue&type=script&lang=ts"

import "./PatientAnagraph.vue?vue&type=style&index=0&id=dfe8c068&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/PatientDetail/PatientAnagraph.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dfe8c068"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dfe8c068', __exports__)) {
    api.reload('dfe8c068', __exports__)
  }
  
  module.hot.accept("./PatientAnagraph.vue?vue&type=template&id=dfe8c068&ts=true", () => {
    api.rerender('dfe8c068', render)
  })

}


export default __exports__